import { number_from_query, str_from_query } from "@/api";
import { fetchLastActivity, type LastActivity } from "@/api/lastActivity";
import { router } from "@/router/router";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { use_client_detail } from "../useClientDetail";

export const use_last_activity = defineStore("last_activity", () => {
  const client_detail_store = use_client_detail();
  const last_activities = ref<LastActivity[]>([]);
  const total_filter = ref<number>(0);
  const total_pages = computed(() =>
    Math.max(1, Math.ceil(total_filter.value / number_from_query("size", 24))),
  );

  const loading = ref({
    get_last_activities: false,
  });

  const action_id = computed(() =>
    String(router.currentRoute.value.params.action_id),
  );
  const keyword = computed(() => str_from_query("keyword") ?? "");
  const page = computed(() => number_from_query("page", 1));
  const size = computed(() => number_from_query("size", 24));

  const get_last_activities = async () => {
    if (!action_id.value) return;
    loading.value.get_last_activities = true;
    try {
      const response = await fetchLastActivity(
        client_detail_store.id,
        action_id.value,
        keyword.value,
        page.value,
        size.value,
      );
      last_activities.value = response.data.data ?? [];
      total_filter.value = response.data.total_filter ?? 0;
    } catch (err) {
      console.error(err);
    } finally {
      loading.value.get_last_activities = false;
    }
  };

  watch(
    () => [action_id.value, keyword.value, page.value, size.value],
    () => get_last_activities(),
    { immediate: true },
  );

  return {
    last_activities,
    total_filter,
    total_pages,
    loading,
    get_last_activities,
  };
});
